import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./TypingEffect.module.css";

const TypingEffect = ({
  text,
  speed = 250,
  cursor = true,
  className = "",
  onComplete = null,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    if (currentIndex < text.length) {
      setIsTyping(true);
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text[currentIndex]);
        setCurrentIndex((prev) => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    } else {
      setIsTyping(false);
      if (onComplete) {
        onComplete();
      }
    }
  }, [currentIndex, text, speed, onComplete]);

  return (
    <span className={`${styles.typingContainer} ${className}`}>
      {displayedText}
      {cursor && (
        <span
          className={`${styles.cursor} ${
            isTyping ? styles.typing : styles.blinking
          }`}
        >
          |
        </span>
      )}
    </span>
  );
};

TypingEffect.propTypes = {
  text: PropTypes.string.isRequired,
  speed: PropTypes.number,
  delay: PropTypes.number,
  cursor: PropTypes.bool,
  className: PropTypes.string,
  onComplete: PropTypes.func,
};

export default TypingEffect;
